export default {
	list: 'Countries',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		CountryName: {
			class: 'value',
			dataName: 'CountryName',
			type: 'string',
			title: 'Country Name',
			width: 100,
			hidden: false
		},
		CountryCode: {
			class: 'value',
			dataName: 'CountryCode',
			type: 'string',
			title: 'Country Code',
			width: 100,
			hidden: false
		}
	}
}